'use client';
import { platform } from './platform.js';
import { computePosition as computePosition$1 } from '../core/computePosition.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const computePosition = (reference, floating, options)=>{
    /*
     * This caches the expensive `getClippingElementAncestors` function so that
     * multiple lifecycle resets re-use the same result. It only lives for a
     * single call. If other functions become expensive, we can add them as well.
     * */ const cache = new Map();
    const mergedOptions = _extends({
        platform
    }, options);
    const platformWithCache = _extends({}, mergedOptions.platform, {
        _c: cache
    });
    return computePosition$1(reference, floating, _extends({}, mergedOptions, {
        platform: platformWithCache
    }));
};

export { computePosition };
//# sourceMappingURL=computePosition.js.map
